
import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import { Form } from 'element-ui';
@Component
export default class extends Vue {
  @Prop() editCloudRecharge!: any;
  @Prop() dialogVisible!: Boolean;
  @Prop() titleVaule!: String;
  rules = {
    cloudvalue: [{ required: true, message: '填入100的倍数', trigger: 'blur', validator: this.checkValue }],
    price: [{ required: true, message: '请输入价格', trigger: 'blur', validator: this.checkPrice }],
    desc: [{ required: true, message: '输入不超过15个字', trigger: 'blur' }],
  };

  @Emit('handleClose')
  handleClose(formName: any) {
    (this.$refs[formName] as Form).resetFields();
  }

  checkValue(rule: any, value: any, callback: any) {
    if (this.editCloudRecharge.value % 100 === 0) {
      return callback();
    } else {
      return callback(new Error('请填写填入100的倍数！'));
    }
  }

  checkPrice(rule: any, value: any, callback: any) {
    if (!isNaN(this.editCloudRecharge.price)) {
      return callback();
    } else {
      return callback(new Error('请填写填入数字价格, 保留2位小数！'));
    }
  }

  editSure(formName: any) {
    (this.$refs[formName] as Form).validate((valid: boolean) => {
      if (valid) {
        const item = JSON.parse(JSON.stringify(this.editCloudRecharge));
        item.price = Number((item.price * 100).toFixed(0));
        this.$emit('editSure', item);
      } else {
        return false;
      }
    });
  }
}
